import {observable} from 'mobx';
import _ from 'lodash';
import App from './App';
import Category from './Category';

class ShortcutApp {
  id;

  name;

  nameEn;

  nameZh;

  description;

  nameJson;

  descriptionJson;

  @observable
  category = new Category();

  @observable
  sourceApp = new App();

  updateFromJson(json) {
    this.id = json.id;
    this.name = json.name;
    this.nameEn = json.nameEn;
    this.nameZh = json.nameZh;
    this.description = json.description;
    if (Object.keys(json.category).length) {
      this.category.id = json.category.id;
      this.category.name = json.category.name;
    }
    if (!_.isEmpty(json.sourceApp)) {
      this.sourceApp.id = json.sourceApp.id;
      this.sourceApp.name = json.sourceApp.name;
      this.sourceApp.nameEn = json.sourceApp.nameEn;
      this.sourceApp.nameZh = json.sourceApp.nameZh;
    }
    this.nameJson = json.nameJson;
    this.descriptionJson = json.descriptionJson;
  }
}

export default ShortcutApp;
